module.exports = __webpack_public_path__ + "papier_peint_vinyle.png?3f188964406c31b325704118f8f48692";